import React from "react";
import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard,
  Home,
  FileText,
  Newspaper,
  Inbox,
  LogOut,
  Languages,
  Loader2,
} from "lucide-react";

const links = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
  { to: "/admin/developments", label: "Developments", icon: Home, testId: "admin-nav-developments" },
  { to: "/admin/pages", label: "Site Pages", icon: FileText, testId: "admin-nav-pages" },
  { to: "/admin/blog", label: "Blog", icon: Newspaper, testId: "admin-nav-blog" },
  { to: "/admin/leads", label: "Leads", icon: Inbox, testId: "admin-nav-leads" },
  { to: "/admin/translations", label: "Translations", icon: Languages, testId: "admin-nav-translations" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[#C5A880]" strokeWidth={1.5} />
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen bg-[#F9F6F0] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#1A1A1A] text-[#F9F6F0] flex flex-col min-h-screen sticky top-0">
        <div className="px-6 py-8 border-b border-[#333]">
          <Link to="/" className="block">
            <span
              className="text-2xl font-light"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Finca Cortesín
            </span>
            <span className="block text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mt-1">
              Webmaster
            </span>
          </Link>
        </div>
        <nav className="flex-1 py-6">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 text-[11px] tracking-[0.2em] uppercase transition-colors ${
                  isActive
                    ? "bg-[#333] text-[#C5A880] border-l-2 border-[#C5A880]"
                    : "text-[#A8A39A] hover:text-[#F9F6F0]"
                }`
              }
            >
              <l.icon className="w-4 h-4" strokeWidth={1.5} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[#333] px-6 py-4">
          <p className="text-[10px] tracking-[0.2em] uppercase text-[#A8A39A] mb-2">
            Signed in
          </p>
          <p className="text-sm text-[#F9F6F0] truncate">{user.email}</p>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="mt-4 flex items-center gap-2 text-[10px] tracking-[0.2em] uppercase text-[#A8A39A] hover:text-[#C5A880]"
          >
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
